import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import HomePage from "@/pages/HomePage";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
          <WhatsAppButton />
        </BrowserRouter>
      </MotionConfig>
    </div>
  );
}

export default App;
